import React, { useState } from 'react'
import teamIcon from "../../assets/icons/mangment icons/team.png"
import titleIcon from "../../assets/icons/mangment icons/title.png"
import permissionGroupIcon from "../../assets/icons/mangment icons/PermissionGroup.png"
import adminIcon from "../../assets/icons/mangment icons/admin.png"
import { ADMIN_PAGE_LABELS } from "../../navigation/adminNavigation"


const TitleHooks = () => {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
    const [search, setSearch] = useState(false)
  
  
    const NavItems = [
   
      { name: ADMIN_PAGE_LABELS.roles, to: "/management/permissiongroup", icon: permissionGroupIcon },
      { name: ADMIN_PAGE_LABELS.admins, to: "/management/admins", icon: adminIcon },
    ];

    

  return {
    NavItems,
    setSearch,
    handleShow,
    show,
    handleClose
  }
}

export default TitleHooks
